import { EpicRefined } from 'interfaces/middleware'
import { AdvisorPublicActions, GetPublicAdvisorTimeslotsAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'
import { filterRequest, filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { mergeMap, map, take } from 'rxjs/operators'
import { GetAdvisorTimeslotsAction, AdvisorMeetingActions } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { merge, of, race } from 'rxjs'
import FloatingPaneAction, { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

export const getPublicProfileTimeslotsEpic: EpicRefined<AdvisorPublicActions | AdvisorMeetingActions | FloatingPaneAction> = (action$) => action$.pipe(
  filterRequest(GetPublicAdvisorTimeslotsAction.type),
  mergeMap((action) => {
    const success$ = action$.pipe(
      filterRequestOfType(GetAdvisorTimeslotsAction.type, 'success'),
      take(1),
    )

    const response$ = success$.pipe(
      mergeMap((timeslotAction) => merge(
        of(modifyFloatingPaneActionCreator('advisor', { mode: 'request', step: 'schedule', fields: action.payload.params })),
        of(action.success(timeslotAction.payload.response)),
      ))
    )

    const fail$ = action$.pipe(
      filterRequestOfType(GetAdvisorTimeslotsAction.type, 'fail'),
      take(1),
      map(() => action.fail())
    )

    return merge(
      race(
        response$,
        fail$,
      ),
      of(new GetAdvisorTimeslotsAction(action.payload.params))
    )
  }),
)
